import { defineComponent, computed } from 'vue';
import { QuestionTypeEmits, QuestionTypeProps } from '@/survey/models/QuestionType';
import RadioOption from '@/survey/models/RadioOption';
import i18n from '@/i18n';

export default defineComponent({
    emits: QuestionTypeEmits,
    props: QuestionTypeProps,
    setup(props, context) {
        const onSelect = (option) => {
            const answer = {
                value: option,
            };
            context.emit('selected', answer);
        };

        const dropdownOptions = computed(() => {
            return props.question.answerOptions.map((option: RadioOption) => {
                return {
                    ...option,
                    alias: option.alias,
                };
            });
        });

        const getCountryTranslation = (countryCode: string): string => {
            const regionNames = new Intl.DisplayNames([i18n.global.locale], { type: 'region' });
            return regionNames.of(countryCode.toUpperCase());
        };

        return {
            onSelect,
            dropdownOptions,
            getCountryTranslation,
        };
    },
});
